import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["innerHTML"]

import { format, useDialogPluginComponent } from "quasar"
import SfxBtn from "src/components/button/SfxBtn.vue"
import SfxBtnOutline from "src/components/button/SfxBtnOutline.vue"
import { computed } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxDialogConfirmation',
  props: {
  modelValue: {
    type: Boolean,
    default: undefined,
  },

  title: {
    type: String,
  },

  content: {
    type: String,
  },

  html: {
    type: Boolean,
    default: false,
  },

  persistent: {
    type: Boolean,
    default: false,
  },

  confirmButtonClasses: {
    type: String,
  },

  confirmButtonText: {
    type: String,
    default: () => {
      const { t } = useI18n()
      return format.capitalize(t("sfxButtons.btn_confirm"))
    },
  },

  rejectButtonText: {
    type: String,
    default: () => {
      const { t } = useI18n()
      return format.capitalize(t("sfxButtons.btn_cancel"))
    },
  },
},
  emits: [...useDialogPluginComponent.emits, "update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

//endregion

//region Variables

const model = computed({
  get() {
    return props.modelValue
  },

  set(value) {
    return emit("update:modelValue", value)
  },
})

const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent()

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef,
    onHide: _unref(onDialogHide),
    persistent: props.persistent,
    modelValue: model.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "q-dialog-plugin" }, {
        default: _withCtx(() => [
          (props.title)
            ? (_openBlock(), _createBlock(_component_q_card_section, {
                key: 0,
                class: "q-dialog__title text-h3 q-pb-xs"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(props.title), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (props.content)
            ? (_openBlock(), _createBlock(_component_q_card_section, {
                key: 1,
                class: "text-body1 sfx-confirm-content"
              }, {
                default: _withCtx(() => [
                  (props.html)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        innerHTML: props.content
                      }, null, 8, _hoisted_1))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(props.content), 1)
                      ], 64))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_q_card_actions, { class: "q-px-md q-pb-md" }, {
            default: _withCtx(() => [
              _createVNode(SfxBtnOutline, {
                onClick: _unref(onDialogCancel),
                label: props.rejectButtonText,
                class: "col q-mr-sm"
              }, null, 8, ["onClick", "label"]),
              _createVNode(SfxBtn, {
                onClick: _unref(onDialogOK),
                label: props.confirmButtonText,
                class: _normalizeClass(["col", __props.confirmButtonClasses])
              }, null, 8, ["onClick", "label", "class"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onHide", "persistent", "modelValue"]))
}
}

})